<div class="w-full">

  @if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }}
  </label>
  }

  <div class="relative w-full">

    <!-- ── Trigger ──────────────────────────────────────── -->
    <div
      (click)="toggleDropdown()"
      class="flex h-11 w-full cursor-pointer items-center justify-between rounded-lg border bg-white px-3 shadow-theme-xs transition-colors dark:bg-gray-900"
      [class.border-brand-300]="isOpen"
      [class.ring-3]="isOpen"
      [class.ring-brand-500/10]="isOpen"
      [class.border-gray-300]="!isOpen"
      [class.dark:border-gray-700]="true"
      [class.opacity-60]="disabled"
      [class.cursor-not-allowed]="disabled"
    >

      <!-- Contenido seleccionado -->
      <div class="flex flex-1 min-w-0 items-center gap-2 overflow-hidden">

        @if (selectedOptions.length === 0) {
        <span class="text-sm text-gray-400 dark:text-white/30 select-none">Sin selección</span>
        } @else if (selectedOptions.length === 1) {
        <span
          class="inline-flex max-w-full items-center gap-1 truncate rounded-md bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-900/30 dark:text-brand-300">
          <span class="truncate">{{ selectedValuesText[0] }}</span>
          <button type="button"
            (click)="removeOption(selectedOptions[0]); $event.stopPropagation()"
            class="shrink-0 ml-0.5 text-brand-400 hover:text-brand-700 dark:hover:text-brand-200 transition-colors">
            <svg width="11" height="11" viewBox="0 0 14 14" fill="currentColor">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.407 4.469a.75.75 0 011.06-1.061L7 5.94l2.532-2.532a.75.75 0 111.06 1.06L8.061 7l2.531 2.532a.75.75 0 11-1.06 1.06L7 8.061 4.468 10.593a.75.75 0 01-1.06-1.06L5.939 7 3.407 4.469z" />
            </svg>
          </button>
        </span>
        } @else {
        <span
          class="inline-flex shrink-0 items-center gap-1 rounded-md bg-brand-50 px-2 py-0.5 text-xs font-semibold text-brand-700 dark:bg-brand-900/30 dark:text-brand-300">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          {{ selectedOptions.length }} seleccionados
        </span>
        <button type="button"
          (click)="clearAll(); $event.stopPropagation()"
          class="shrink-0 text-xs text-gray-400 underline hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors">
          Limpiar
        </button>
        }

      </div>

      <!-- Chevron -->
      <svg
        class="shrink-0 ml-2 text-gray-400 transition-transform duration-200 dark:text-gray-500"
        [class.rotate-180]="isOpen"
        width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M4.79175 7.39551L10.0001 12.6038L15.2084 7.39551"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </div>

    <!-- ── Dropdown ──────────────────────────────────────── -->
    @if (isOpen) {
    <div
      class="absolute left-0 top-full z-50 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900"
      (click)="$event.stopPropagation()">

      <div class="max-h-52 overflow-y-auto">

        @if (options.length === 0) {
        <div class="px-3 py-4 text-center text-sm text-gray-400 dark:text-gray-500">
          Sin opciones disponibles
        </div>
        }

        @for (option of options; track $index) {
        <div
          (click)="handleSelect(option.value)"
          class="flex cursor-pointer items-center justify-between px-3 py-2.5 text-sm transition-colors"
          [class.bg-brand-50]="selectedOptions.includes(option.value)"
          [class.dark:bg-brand-900/20]="selectedOptions.includes(option.value)"
          [class.hover:bg-gray-50]="!selectedOptions.includes(option.value)"
          [class.dark:hover:bg-gray-800]="!selectedOptions.includes(option.value)"
          [class.hover:bg-brand-50/70]="selectedOptions.includes(option.value)"
        >
          <span
            class="leading-snug"
            [class.text-brand-700]="selectedOptions.includes(option.value)"
            [class.dark:text-brand-300]="selectedOptions.includes(option.value)"
            [class.font-medium]="selectedOptions.includes(option.value)"
            [class.text-gray-700]="!selectedOptions.includes(option.value)"
            [class.dark:text-gray-300]="!selectedOptions.includes(option.value)"
          >
            {{ option.text }}
          </span>

          @if (selectedOptions.includes(option.value)) {
          <svg class="shrink-0 text-brand-500" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          }
        </div>
        }

      </div>
    </div>
    }

  </div>
</div>
